<br />
<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <td>
        <div style="margin-right: 50px">
          <label class="control-label">Geography Coverage Type</label>
          <app-select
            id="locationCoverageType"
            name="locationCoverageType"
            #locationCoverageType
            [items]="locationCoverageTypeOptions"
            [allowClear]="true"
            [selected]="locationTypeChanged"
            [removed]="locationTypeCleared"
            placeholder="Select Geography Coverage Type"
          >
          </app-select>
        </div>
      </td>
      <td>
        <div *ngIf="this.distanceVisible()">
          <label class="control-label">Miles Covered</label>
          <input
            id="locationCoverageDistance"
            name="LocationCoverageDistance"
            type="number"
            min="0"
            appOnlyDigits
            class="form-control"
            [(ngModel)]="model.LocationCoverageDistance"
          />
        </div>
      </td>
    </div>
  </div>
</div>

<div *ngIf="this.distanceVisible()">
  <div class="row">
    <div class="col-md-6">
      <h4>Available Border State(s) Inclusions</h4>
    </div>
    <div class="col-md-6">
      <h4>Selected Border State(s) Inclusions</h4>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-6">
    <app-grid-wrapper #available (cellDoubleClicked)="select()" [hidden]="!this.distanceVisible()">
      <div class="row">
        <div class="col-xs-9">
          <button
            type="button"
            class="btn btn-default"
            [disabled]="availableSelection.length === 0"
            (click)="select()"
          >
            <i class="fa fa-arrow-right"></i> Add To Selected
          </button>
        </div>
      </div>
    </app-grid-wrapper>
  </div>

  <div class="col-md-6">
    <app-grid-wrapper #selected (cellDoubleClicked)="remove()" [hidden]="!this.distanceVisible()">
      <button
        type="button"
        class="btn btn-default"
        [disabled]="selectedSelection.length === 0"
        (click)="remove()"
      >
        <i class="fa fa-arrow-left"></i> Remove from Selected
      </button>
    </app-grid-wrapper>
  </div>
</div>
